import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";
import Spinner from "../Components/Spinner";
import { BsLayoutSidebarInset } from "react-icons/bs";
import { FiSidebar } from "react-icons/fi";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

function Navbar({ title, toggleSidebar, sidebarOpen, showToggle = true }) {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const { t } = useLanguage();
    const [loading, setLoading] = useState(false)
    const [err, setErr] = useState({ message: "", display: false });
    const [rememberUser, setRememberUser] = useState(null)
    const [isMobile, setIsMobile] = useState(false);

    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        }
        return null;
    }

    useEffect(() => {
        setRememberUser(getCookie("account_id"));


        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    function DirectLogin() {
        setLoading(true);
        const dataToSend = {
            account_id: rememberUser,
        };

        fetch(`${GEN_BACKEND_LINK}/direct_login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend),
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if (data.message === "OK") {
                    const db_id = data.account_id;
                    const email = data.email;
                    localStorage.setItem("account_id", db_id);
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    if (isMobile) {
                        navigate("/mobile_device");
                    } else {
                        if (data.email_verified) {
                            if (data.onboarding.completed) {
                                navigate("/e8console/organizations");
                            } else {
                                navigate(`/onboarding/welcome`);
                            }
                        } else {
                            navigate(`/verify-email?email=${email}`);
                        }
                    }
                } else {
                    navigate("/login");
                }
            })
            .catch(error => {
                setLoading(false);
                setErr({ message: t.register_form.problem_back, display: true });
            });
    }

    const GoLogo = () => {
        navigate("/logo")
    }

    const navigateUrl = () => {
        window.location.href = "https://t0.projecte8.com/join-waitlist";
    }

    const navigateUrlSales = () => {
        navigate("/contact/sales")
    }

    return (
        <div className={`main_navbar ${scrolled ? "scrolled" : ""}`}>
            <div className="navbar">
                <div className="nav_cont_1">
                    <p id="title_navbar">
                        {/* <i><TbGalaxy /></i> */}
                        <a href="/">
                            Project E8 {" "}
                        </a>
                        <span>{title}</span>
                        {/* {showToggle && (
                            sidebarOpen ? (
                                <button className="sidebar_home_toggle" onClick={toggleSidebar}><BsLayoutSidebarInset /></button>
                            ) : (
                                <button className="sidebar_home_toggle" onClick={toggleSidebar}><FiSidebar /></button>
                            )
                        )} */}
                    </p>
                </div>
                <div className="nav_cont_1">
                    <div>
                        {rememberUser ? (
                            isMobile ? (
                                <button className="waitin_list_btn" onClick={() => GoLogo()}>
                                    {loading ? (
                                        <Spinner loading={loading} />
                                    ) : (
                                        <>
                                            {t.website.navbar.dashboard} <i className="fa-solid fa-arrow-right"></i>
                                        </>
                                    )}
                                </button>
                            ) : (
                                <button className="waitin_list_btn" onClick={() => DirectLogin()}>
                                    {loading ? (
                                        <Spinner loading={loading} />
                                    ) : (
                                        <>
                                            {t.website.navbar.dashboard} <i className="fa-solid fa-arrow-right"></i>
                                        </>
                                    )}
                                </button>
                            )

                        ) : (
                            <div className={`register_btn_nav_cont ${scrolled ? "register_btn_nav_scrolled_cont" : ""}`}>
                                {/* <button className="login_btn" onClick={() => navigate("/login")}>
                                    {t.website.navbar.login} <i className="fa-solid fa-login"></i>
                                </button>
                                <button className="start_now_btn" onClick={() => navigate("/register")}>
                                    {t.website.navbar.start_now}
                                </button> */}
                                {/* <button className="waitin_list_btn" onClick={navigateUrl}>
                                    {t.website.navbar.waitlist}
                                </button> */}
                                <button className="waitin_list_btn" onClick={navigateUrlSales}>
                                    {t.website.sales.contact_btn}
                                </button>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
